import { useState } from 'react';
import './forms.css';

export default function ContactForm() {
  const [notice, setNotice] = useState('');

  function submitContact(event) {
    event.preventDefault();
    setNotice('This message was not sent or stored. Connect a backend to receive contact enquiries.');
  }

  return (
    <form className="site-form contact-form" onSubmit={submitContact}>
      <h2>Send an enquiry</h2>
      <label className="form-field">
        <span>Name</span>
        <input type="text" name="name" autoComplete="name" required />
      </label>
      <label className="form-field">
        <span>Email</span>
        <input type="email" name="email" autoComplete="email" required />
      </label>
      <label className="form-field">
        <span>Phone</span>
        <input type="tel" name="phone" autoComplete="tel" />
      </label>
      <label className="form-field">
        <span>Message</span>
        <textarea name="message" rows="5" required />
      </label>
      <button className="button button-gold" type="submit">Send message</button>
      {notice && <p className="form-status" role="status">{notice}</p>}
    </form>
  );
}